import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import AppBar from '@mui/material/AppBar';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import { Box, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@material-ui/icons';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { styled } from '@material-ui/styles';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DoneIcon from '@material-ui/icons/Done';
import ChatIcon from '@mui/icons-material/Chat';
import VariationsIcon from '@mui/icons-material/ViewCarousel';
import moment from 'moment';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../assets/imgs/office.png';
import Notifications from '@mui/icons-material/Notifications';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ReplyIcon from '@mui/icons-material/Reply';

import InventoryIcon from "@mui/icons-material/Inventory"; // ícone de caixa / estoque

import GerenciarReserva from '../OrdensDeServicos/gerenciarReserva.js';

import api from '../../../../../services/api';
import { returnDescricaoInsumo } from '../../../../../utils/insumoHelpers';

import {
    DataGrid, ptBR,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import {
    MaterialReactTable
} from 'material-react-table';


import NavegadorGestao from '../../../../../components/NavBarGestao';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';

import { Email, EmailOutlined, Visibility, VisibilityOff, Message, MessageOutlined } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';



const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));


const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));



export default function EditarListaRequerimentos() {

    const [openGerenciarReserva, setOpenGerenciarReserva] = useState(false);
    
    
        const [reservaGerenciada, setReservaGerenciada] = useState(null);
    
        function handleGerenciarReserva(reserva){
            setReservaGerenciada(reserva);
            setOpenGerenciarReserva(true);
        }
    
    
        function handleCloseGerenciarReserva(){
            setOpenGerenciarReserva(false);
            setReservaGerenciada(false);
            recarregarItens();
        }
    

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });





    const [loading, setLoading] = useState(true);


    const [ordemCompra, setOrdemCompra] = useState(null);
    const { idOrdemCompra } = useParams();



    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);
    const [observacoesItem, setObservacoesItem] = useState('');
    const [descricaoNovoInsumo, setDescricaoNovoInsumo] = useState('');
    const [descricao, setDescricao] = useState('');

    const [quantidadeDoEstoque, setQuantidadeDoEstoque] = useState(0);
    const [quantidadeNoEstoque, setQuantidadeNoEstoque] = useState(0);

    const [temEstoque, setTemEstoque] = useState(false);

    function handleSetInsumo(insumo) {
        setInsumoSelecionado(insumo);
    }



    function handleSetInsumoSelecionado(insumo_) {
        try {
            const insumo = insumo_.insumo;
        } catch (_err) {
            setInsumoSelecionado(null);

            return;
        }

        try {
            if (Array.isArray(insumo_.itens_estoque) && insumo_.itens_estoque.length > 0) {
                const itensDisponiveis = insumo_.itens_estoque.filter(item => item.status_item === 0);

                if (itensDisponiveis.length > 0) {
                    setTemEstoque(true);
                    setQuantidadeNoEstoque(itensDisponiveis.length);
                } else {
                    setTemEstoque(false);
                    setQuantidadeNoEstoque(0);
                }
            } else {
                setTemEstoque(false);
                setQuantidadeNoEstoque(0);
            }
        } catch (_err) {
            setTemEstoque(false);
            setQuantidadeNoEstoque(0);
            console.error("Erro ao verificar itens de estoque:", _err);
            setInsumoSelecionado(null);

            return;
        }

        setInsumoSelecionado(insumo_);
    }

    function handleSetQuantidadeDoEstoque(valor) {
        const valorNumerico = parseFloat(valor);

        if (valor === "") {
            setQuantidadeDoEstoque("");
            return;
        }

        if (!isNaN(valorNumerico) && valorNumerico <= quantidade && valorNumerico <= quantidadeNoEstoque) {
            setQuantidadeDoEstoque(valor);
        } else {
            // alert(`A quantidade informada deve ser no máximo ${Math.min(quantidade, quantidadeNoEstoque)}.`);
        }
    }


    async function listarInformacoes() {
        try {


            const token = Cookies.get('token');

            let status_ordem = -1;
            let isSolicitanteLocal = false;

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                headers: headers
            }).then(function (response) {

                console.log("ordem de compra listada!");

                const ordem_compra = response.data.ordem_compra;
                setOrdemCompra(ordem_compra);





                setLoading(false);

            });

        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    async function recarregarItens() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                headers: headers
            }).then(function (response) {

                console.log("ordem de compra listada!");

                const ordem_compra = response.data.ordem_compra;
                setOrdemCompra(ordem_compra);


                setLoading(false);



            });



        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }
    }




    useEffect(() => {


        listarInformacoes();


    }, []);



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {

        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };



    function returnDescricaoInsumo2(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }




        if (insumo.cotacoes && insumo.cotacoes.length > 0) {
            const cotacoesOrdenadas = [...insumo.cotacoes].sort((a, b) => new Date(a.data) - new Date(b.data));

            // Formata número para moeda brasileira
            const formatarValor = (valor) =>
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

            // Formata data para pt-BR
            const formatarData = (data) =>
                new Date(data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

            // Constrói o texto com as cotações formatadas
            textoComQuebraDeLinha += cotacoesOrdenadas
                .map((cotacao, index) => {
                    return `<br />*Cotação -> ${formatarValor(cotacao.valor_unitario)} em ${formatarData(cotacao.data)}`;
                })
                .join('');

            // Cálculo da média
            const soma = cotacoesOrdenadas.reduce((acc, c) => acc + c.valor_unitario, 0);
            const media = soma / cotacoesOrdenadas.length;
            textoComQuebraDeLinha += `<br />Valor médio: ${formatarValor(media)}`;

            // Última cotação (maior data após ordenação)
            const ultimaCotacao = cotacoesOrdenadas[cotacoesOrdenadas.length - 1];
            textoComQuebraDeLinha += `<br />Última Cotação: ${formatarValor(ultimaCotacao.valor_unitario)} em ${formatarData(ultimaCotacao.data)}`;
        }




        var texto =

            //"<br />Marca/Modelo: " + insumo.marca + "/" + insumo.modelo +
            // "<br />Código Fornecedor: " + insumo.codigo_fornecedor +
            //"<br />Tipo: " + insumo.tipo +
            //"<br />Categoria: " + insumo.categoria +
            textoComQuebraDeLinha + "<br />Estoque: " + (Array.isArray(insumo_.itens_estoque) ? insumo_.itens_estoque.length : 0) + " unidades";
        return texto;
    }



    function returnDescricaoInsumoSimplificada(insumo) {
        try {
            // Tenta acessar diretamente insumo.descricao
            if (insumo?.descricao) {
                return insumo.id_insumo + " Descrição: " + insumo.descricao;
            }

            // Se não houver, tenta insumo.insumo.descricao
            if (insumo?.insumo?.descricao) {
                return insumo.insumo.descricao + " Descrição: " + insumo.insumo.descricao;
            }

            // Se nenhum dos dois funcionar
            return "Descrição: não disponível";
        } catch (error) {
            return "Descrição: erro ao obter";
        }
    }






    const [openAtualizando, setOpenAtualizando] = useState(false);

    const [observacoesEditingValue, setObservacoesEditingValue] = useState('');

    const handleInputObservacoesEditingChange = (event) => {
        const value = event.target.value;
        console.log(value); // imprime tudo que foi digitado, inclusive espaços
        setObservacoesEditingValue(value);
    };



    const handleAtualizarObservacoesAlmoxarifado = async (cellValues) => {

        const id_item_requerimento = cellValues.row.id_item_requerimento;
        const cadastro = {
            observacoes_almoxarifado: observacoesEditingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put(`/v1/protected/ordensdecompras/editarrequerimento/atualizaritem/observacoesalmoxarifado/${id_item_requerimento}`, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {

            recarregarItens();

        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };

    const [quantidadeEditingValue, setQuantidadeEditingValue] = useState(0);
    const handleInputQuantidadeChange = (event) => {
        setQuantidadeEditingValue(event.target.value);
    };


    const handleAtualizarQuantidade = async (cellValues, quantidadeReservada) => {
        const quantidade = cellValues.row.quantidade; // quantidade pedida

        // Validação: não permitir quantidade_reservada maior que quantidade
        if (quantidadeReservada > quantidade) {
            alert(`A quantidade reservada não pode ser maior que a quantidade pedida (${quantidade})`);
            return; // sai da função sem chamar a API
        }

        setOpenAtualizando(true);

        const id = cellValues.row.id_item_requerimento;
        const cadastro = {
            quantidade_reservada: quantidadeReservada,
        };

        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        };

        try {
            const response = await api.put(
                '/v1/protected/ordensdecompras/' + idOrdemCompra + '/editarrequerimento/atualizaritem/quantidadereservada/' + id,
                cadastro,
                { headers: headers }
            );

            const cadastro_salvo = response.data;
            if (!cadastro_salvo) {
                alert("Erro de Conexão, tente novamente mais tarde");
            } else {
                recarregarItens();
            }
        } catch (error) {
            alert(error.response?.data || "Erro ao atualizar quantidade");
        } finally {
            setOpenAtualizando(false);
        }
    };



    const [insumoKey, setInsumoKey] = useState(0);


    const [informacoesEstoqueInsumo, setInformacoesEstoqueInsumo] = useState(null);

    async function consultarEstoqueItem(id_insumo) {
        console.log("funcao chamada!");
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidoporid/${id_insumo}`,
                { headers }
            );

            console.log(JSON.stringify(response.data));
            let texto = returnDescricaoInsumo(response.data[0]);
            setInformacoesEstoqueInsumo(texto);
            // setInsumoKey(prev => prev + 1);


        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }

    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 50,
            renderCell: (cellValues) => {

                return (

                    <IconButton
                        color="error" // vermelho
                        onClick={(event) => handleClickRemocao(event, cellValues)}
                    >
                        <DeleteIcon />
                    </IconButton>
                )
            },
        },

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 3,
            width: 350,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;

                // 🔍 Detecta automaticamente o ID correto (dependendo do seu backend)
                const idInsumo = insumo?.id_insumo > 0
                    ? insumo.id_insumo
                    : insumo?.insumo?.id_insumo > 0
                        ? insumo.insumo.id_insumo
                        : null;

                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');

                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {/* Texto */}
                        <div
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                wordBreak: 'break-word',
                                flex: 1,
                                marginRight: '8px'
                            }}
                        >
                            {descricao}
                        </div>

                        {/* 🔹 Botão com Tooltip */}
                        {idInsumo ? (
                            <Tooltip
                                title={
                                    <div style={{ backgroundColor: 'white', color: 'black', padding: 10, fontSize: 16 }}>

                                        <div dangerouslySetInnerHTML={{ __html: informacoesEstoqueInsumo ? informacoesEstoqueInsumo : "Sem informações de Estoque" }} />

                                    </div>

                                }
                                placement="top"
                                arrow
                                style={{ backgroundColor: 'white' }}
                                sx={{ backgroundColor: 'white' }}
                            >
                                <IconButton
                                    onClick={() => consultarEstoqueItem(idInsumo)}
                                    size="small"
                                >
                                    <InventoryIcon />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </div>
                );
            },
        },

        {
            headerName: 'Qtd Pedida',
            field: 'quantidade',
            id: 3,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
        /*
        {
            headerName: 'Qtd Reservada',
            field: 'quantidade_reservada',
            width: 100,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const quantidade = cellValues.row.quantidade;
                const quantidadeReservada = cellValues.row.quantidade_reservada;

                const [inputValue, setInputValue] = React.useState(quantidadeReservada);

                return (
                    <TextField
                        value={inputValue}
                        onFocus={() => setInputValue(quantidadeReservada)}
                        onChange={(event) => {
                            let valor = parseInt(event.target.value, 10) || 0;
                            if (valor <= quantidade) {
                                setInputValue(valor);
                            } else {
                                setInputValue(quantidade); // força o valor máximo permitido
                            }
                        }}
                        onBlur={() => {
                            // aqui enviamos exatamente o valor atual do input
                            handleAtualizarQuantidade(cellValues, inputValue);
                        }}
                        variant="outlined"
                    />
                );
            },
        },
        */
       {
           headerName: 'Qtd Reservada',
           field: 'quantidade_reservada',
           width: 160,
           headerClassName: 'cabecalho_azul',
           renderCell: (cellValues) => {
               const quantidadeReservada = cellValues.row.quantidade_reservada;
       
               return (
                   <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                       <span>{quantidadeReservada}</span>
       
                     <Button
           variant="outlined"
           size="small"
           onClick={() => handleGerenciarReserva(cellValues.row)}
       >
           <EditIcon fontSize="small" />
       </Button>
                   </div>
               );
           },
       },
        {
            headerName: 'Qtd a Comprar',
            field: 'quantidade_a_comprar',
            id: 5,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },


        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 6,
            width: 150,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Observações Almoxarife',
            field: 'observacoes_almoxarifado',
            width: 400,
            id: 7,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const observacoes_almoxarifado = cellValues.row.observacoes_almoxarifado || 'NAN';

                return (
                    <TextField
                        defaultValue={observacoes_almoxarifado}
                        onBlur={() => handleAtualizarObservacoesAlmoxarifado(cellValues)}
                        onFocus={() => setObservacoesEditingValue(observacoes_almoxarifado)}
                        onChange={(event) => {
                            console.log("Caractere digitado:", event.nativeEvent.data);
                            console.log("Valor atual:", event.target.value);
                            handleInputObservacoesEditingChange(event);
                        }}
                        onKeyDown={(e) => {
                            if (e.code === "Space") {
                                e.stopPropagation();
                            }
                        }}
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        sx={{
                            maxHeight: 70,
                            overflowY: 'auto' // ✅ habilita scroll vertical
                        }}
                    />
                );
            },
        },
        {
            headerName: '',
            field: 'criado_por',
            id: 8,
            width: 600,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const criador = params.row.usuario_criador;
                const data_ori = params.row.data_hora_criacao;

                var nome = criador.nome_amigavel;
                const data = moment(data_ori, "YYYY-MM-DD HH:mm:ss");
                const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");

                return <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                    adicionado por {nome} em {dataFormatada}
                </span>;
            },
        },



    ];



    async function adicionarItem() {

        if (!insumoSelecionado) {
            if (descricaoNovoInsumo.length <= 0) {
                alert("Selecione o Insumo ou Insira a descrição para um novo Insumo!");
                return;
            } else {

            }

        }

        if (!quantidade || parseInt(quantidade) <= 0) {
            alert("Informe a quantidade!");
            return;
        }

        const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

        try {

            console.log("cadastrar chamado");
            const cadastro = {
                observacoes: observacoesItem,
                quantidade: parseInt(quantidade),
                insumo: insumoSelecionado !== null ? { id_insumo: insumoSelecionado.id_insumo } : null,
                descricao: descricaoNovoInsumo,
                usuario_criador: { id_usuario: id_usuario_logado },


            }

            if (insumoSelecionado) {
                cadastro.id_insumo = insumoSelecionado.insumo.id_insumo;
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }


            if (temEstoque) {
                cadastro.quantidade_reservada = quantidadeDoEstoque;
                cadastro.quantidade_a_comprar = quantidade - quantidadeDoEstoque;
            } else {
                cadastro.quantidade_reservada = 0;
                cadastro.quantidade_a_comprar = quantidade;
            }


            const response = await api.put("/v1/protected/ordensdecompras/editarrequerimento/" + idOrdemCompra + "/inseriritem", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Adicionado!");
                recarregarItens();

                setInsumoSelecionado(null);
                setQuantidade(0);
                setObservacoesItem('');
                setDescricao('');
                setTemEstoque(false);
                setQuantidadeNoEstoque(0);
                setQuantidadeDoEstoque(0)

            } else {
                alert("Erro de Conexão 2 tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão 3" + _err + ", tente novamente mais tarde");

        }




    }




    async function handleClickRemocao(event, cellValues) {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            const response = await api.delete("/v1/protected/ordensdecompras/editarrequerimento/" + idOrdemCompra + "/removeritem/" + cellValues.row.id_item_requerimento,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");
                recarregarItens();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };



    const [textoBusca, setTextoBusca] = useState("");

    useEffect(() => {

        if (textoBusca.length < 3) {
            return; // não busca com menos de 3 chars
        }

        const delayDebounce = setTimeout(() => {
            buscarInsumo(textoBusca);
        }, 500);

        return () => clearTimeout(delayDebounce);

    }, [textoBusca]);

    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }







    return (
        <div style={{ width: '100%', margin: 0, padding: 0 }}>

            <NavegadorGestao
                Gestao={true}
                OrdensCompras={true}
                corFundo={'white'} travado={true} corTexto={'black'}
                style={{ width: '100%', margin: 0, padding: 0 }}

            />

            <div style={{ paddingTop: 5, width: '100%', margin: 0, backgroundColor: 'white' }} >
                {loading
                    ?
                    <div></div>

                    :

                    <div style={{ width: '100%', margin: 0, padding: 0 }}>

                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                            style={{ width: '100%', margin: 0, padding: 0 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                align="flex-start"
                                item xs={12}
                                style={{ padding: 5 }}
                            >
                                <a href={"/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra} style={{ fontSize: 14, color: 'black', marginLeft: '5px' }}>{"< Ordem de Compra nº " + idOrdemCompra}</a>
                            </Grid>

                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >


                                <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                                    <AppBar position="static" >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"
                                            style={{ width: '100%', margin: 0, padding: 0 }}
                                        >
                                            <Tab label="Requerimento de Insumos" style={{ backgroundColor: '#1C1C1C' }} />


                                        </Tabs>
                                    </AppBar>

                                </Box>
                            </Grid>


                            <SwipeableViews
                                index={value}
                                onChangeIndex={handleChangeIndex}
                                style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                            >



                                <Grid value={value} index={0}
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                                >



                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                        style={{ padding: 20 }}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={8}
                                        >

                                            <Autocomplete
                                                id="select-insumo"
                                                options={insumos}
                                                disableCloseOnSelect
                                                getOptionLabel={(insumo) =>
                                                    returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')
                                                }
                                                value={insumoSelecionado}

                                                onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                                // 🔥 captura O TEXTO DIGITADO
                                                onInputChange={(event, newInputValue) => {
                                                    setTextoBusca(newInputValue);
                                                }}

                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((insumo) => {
                                                        const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                                        return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                    });
                                                }}

                                                renderInput={(params) => (
                                                    <TextField {...params} label="Insumo" multiline minRows={2} />
                                                )}

                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                                )}
                                            />
                                        </Grid>


                                        <Grid
                                            container
                                            item xs={2}
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            <TextField
                                                variant="standard"
                                                name="quantidade"
                                                label="Quantidade"
                                                id="quantidade"
                                                value={quantidade}
                                                onChange={(e) => setQuantidade(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                        {temEstoque && (
                                            <Grid
                                                container
                                                item
                                                xs={6} // Aumenta o espaço para comportar o TextField e o Typography
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                spacing={1}
                                            >
                                                <Grid item>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {quantidadeNoEstoque} disponíveis
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body2" color="textSecondary">
                                                        Máx: {Math.min(quantidade, quantidadeNoEstoque)}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    container
                                                    item xs={4}
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    style={{ marginRight: 2 }}
                                                >
                                                    <TextField
                                                        variant="standard"
                                                        name="quantidadeDoEstoque"
                                                        label="Quantidade do Estoque"
                                                        id="quantidadeDoEstoque"
                                                        value={quantidadeDoEstoque}
                                                        inputProps={{
                                                            type: "number",
                                                            min: 0,
                                                            max: Math.min(quantidade, quantidadeNoEstoque)
                                                        }} onChange={(e) => handleSetQuantidadeDoEstoque(e.target.value)}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}



                                        <Grid
                                            container
                                            item xs={12}
                                            justifyContent="center"
                                            alignItems="center"
                                            style={{ paddingTop: 10 }}
                                        >
                                            <TextField
                                                variant="standard"
                                                name="observacoesItem"
                                                label="Observações"
                                                id="observacoesItem"
                                                value={observacoesItem}
                                                onChange={(e) => setObservacoesItem(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={2}
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            item xs={12}
                                            justifyContent="center"
                                            alignItems="center"
                                            style={{ paddingTop: 10 }}
                                        >
                                            <TextField
                                                variant="standard"
                                                name="descricaoNovoInsumo"
                                                label="Descrição para Novo Insumo"
                                                id="descricaoNovoInsumo"
                                                value={descricaoNovoInsumo}
                                                onChange={(e) => setDescricaoNovoInsumo(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={2}
                                            />
                                        </Grid>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            item xs={2}
                                        >
                                            <Button style={{ marginTop: 5 }}
                                                variant="contained"
                                                color="primary"
                                                onClick={(ev) => adicionarItem()}
                                            > Adicionar Item  </Button>
                                        </Grid>





                                    </Grid>







                                    <Grid
                                        style={{ paddingTop: 5 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        {
                                            ordemCompra.itens_pre_requerimento &&
                                            <>
                                                <DataGrid
                                                    key={insumoKey}
                                                    pagination
                                                    checkboxSelection
                                                    rows={ordemCompra.itens_pre_requerimento}
                                                    getRowId={(row) => row.id_item_requerimento}
                                                    columns={columnsDataGrid}
                                                    disableColumnResize={false}
                                                    rowHeight={40}
                                                    onCellClick={handleCellClick}
                                                    onRowClick={handleRowClick}
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}

                                                />

                                            </>
                                        }



                                    </Grid>


                                </Grid>



                            </SwipeableViews>



                        </Grid>

                    </div>
                }
            </div>


            <Snackbar
                open={openAtualizando}
                autoHideDuration={1500}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <MuiAlert elevation={6} variant="filled"  >
                    Atualizando...
                </MuiAlert>
            </Snackbar>



    <Dialog open={openGerenciarReserva} onClose={handleCloseGerenciarReserva} PaperProps={{ style: { maxWidth: '600px', minWidth: '600px', minHeight: '600px' } }}>
                <DialogTitle>Gerenciar Reserva</DialogTitle>
                <DialogContent>
                    
                    <GerenciarReserva idOrdemServico={null} idOrdemCompra={idOrdemCompra}  reserva={reservaGerenciada} onClose={handleCloseGerenciarReserva} />

                </DialogContent>
            </Dialog>



        </div >
    );
}


